module.exports = __webpack_public_path__ + "static/img/智能合同管理平台.f4dbc1e9.png";